import {
  Component,
  OnDestroy,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { ApiService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';
import { UserService } from '../../services/user.service';
import { EnquireService } from '../../services/enquire.service';
import { Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NotificationService } from '../../services/notification.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

interface Enquiry {
  veh_no: string;
  branchName: string;
  statusDescription: string;
  notificationCount: number;
  enqOn: string;
  enquiryId: string;
  statusCode: string;
  buyerCode?: string;
  buyerName?: string;
  buyer_name?: string;
  enquiryNotesId?: string | number;
  type?: string;
}

@Component({
  selector: 'app-enquiry-list',
  templateUrl: './enquiry-list.component.html',
  styleUrl: './enquiry-list.component.scss',
})
export class EnquiryListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('listContainer') listContainer: ElementRef;

  @ViewChild('infiniteAnchor', { static: false })
  set infiniteAnchorRef(ref: ElementRef | undefined) {
    if (ref) {
      this.infiniteAnchor = ref;
      setTimeout(() => this.setupIntersectionObserver(), 0);
    }
  }
  private infiniteAnchor!: ElementRef;
  private io: IntersectionObserver | null = null;

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.dropdown');
    if (!clickedInside) {
      this.isDropdownOpen = false;
    }
  }

  bills: Enquiry[] = [];
  enquiries: Enquiry[] = [];
  enquiriesLoaded: boolean = true;
  showStatusBar: boolean = false;
  isSearchBarVisible: boolean = false;
  isStatusBarVisible: boolean = false;
  isDropdownOpen: boolean = false;
  isRefreshing: boolean = false;
  showEnquiryTypeModal: boolean = false;

  isAdmin: boolean = false;
  showBehalfModal: boolean = false;
  behalfNotes: any[] = [];
  isLoadingNotes: boolean = false;
  enquiryConfig: number = 1;

  openEnquiryModal() {
    if (this.enquiryConfig === 0) {
      this.goTo('new-enquiry', '');
    } else {
      this.showEnquiryTypeModal = true;
    }
  }

  closeEnquiryModal() {
    this.showEnquiryTypeModal = false;
  }

  openBehalfModal() {
    this.closeEnquiryModal();
    this.showBehalfModal = true;
    this.fetchBehalfNotes();
  }

  closeBehalfModal() {
    this.showBehalfModal = false;
  }

  fetchBehalfNotes() {
    this.isLoadingNotes = true;
    this.http.get('retailers/getEnquiryNotes').subscribe({
      next: (res: any) => {
        this.isLoadingNotes = false;
        if (res.code === 1) {
          this.behalfNotes = res.data || [];
        } else {
          this.toastr.error(res.message);
        }
      },
      error: () => {
        this.isLoadingNotes = false;
        this.toastr.error('Failed to fetch behalf notes');
      }
    });
  }

  selectBehalfNote(noteId: number | string) {
    this.closeBehalfModal();
    this.router.navigate(['/dashboard/new-enquiry'], { queryParams: { note_id: noteId } });
  }

  enqList = {};
  userData = {};
  accType: number = 1;
  segmentValue: string = '1';
  enqPage = 1;
  billPage = 1;
  limit = 10;
  hasMoreData: boolean = true;
  selectedStatuses: number[] = [];
  searchTerm: string = '';
  private enquirySubscription: Subscription;
  private searchSubject = new Subject<string>();
  statuses: any[] = [];
  isInfiniteScrollEnabled = true;
  isLoading: boolean = false;
  currentTab = 'ENQUIRIES';
  brandName: string = 'AzeApp';

  buyerEnqStatuses = [
    { id: 1, name: 'Enq Placed' },
    { id: 2, name: 'Estimate Received' },
    { id: 3, name: 'Add info required' },
    { id: 4, name: 'Order Placed' },
  ];

  buyerBillStatuses = [
    { id: 5, name: 'Billed/Intransit' },
    { id: 6, name: 'Billed/Delivered' },
    { id: 7, name: 'Pending for invoice' },
  ];

  sellerEnqStatuses = [
    { id: 1, name: 'New Enquiry' },
    { id: 2, name: 'Estimate Sent' },
    { id: 3, name: 'Add info required' },
    { id: 4, name: 'Order Placed' },
  ];

  sellerBillStatuses = [
    { id: 5, name: 'Billed/Intransit' },
    { id: 6, name: 'Billed/Delivered' },
  ];
  statusBasedIconList = {
    'Enquiry Placed': 'fa-clipboard',
    'New Enquiry': 'fa-file',
    'Estimate received': 'fa-file-text',
    'Estimate Sent': 'fa-calculator',
    'Additional info required': 'fa-info-circle',
    'Order Placed': 'fa-shopping-cart',
    'Billed/intrasit': 'fa-receipt',
    'Billed/Delivered': 'fa-check-circle',
    'Pending for invoice': 'fa-clock',
    'Order Closed': 'fa-times-circle',
    'Not Available': 'fa-exclamation-circle',
    'Return Raised': 'fa-reply',
    'Pending For Return Approval': 'fa-question-circle',
    'Return Approved': 'fa-thumbs-up',
    'Pickup in progress': 'fa-regular fa-truck-pickup',
    'Pending For POD Approval': 'fa-regular fa-clock',
    'Dispatch Confirmation Pending': 'fa-regular fa-box-open',
    'Estimate Partially Received': 'fa-regular fa-boxes',
    'Estimate Partially Sent': 'fa-regular fa-boxes',
  };
  statusBasedColorList = {
    'Enquiry Placed': 'orange',
    'New Enquiry': 'red',
    'Estimate received': 'red',
    'Estimate Sent': 'orange',
    'Additional info required': 'red',
    'Order Placed': 'orange',
    'Billed/intrasit': 'orange',
    'Billed/Delivered': 'green',
    'Pending for invoice': 'orange',
    'Order Closed': 'gray',
    'Not Available': 'gray',
    'Return Raised': 'red',
    'Pending For Return Approval': 'orange',
    'Return Approved': 'green',
    'Pickup in progress': 'orange',
    'Pending For POD Approval': 'red',
    'Dispatch Confirmation Pending': 'red',
    'Estimate Partially Received': 'purple',
    'Estimate Partially Sent': 'purple',
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: StorageService,
    private user: UserService,
    private http: ApiService,
    private enq: EnquireService,
    private NotificationService: NotificationService,
    private toastr: ToastrService
  ) {}

  toggleSearchBar() {
    this.isSearchBarVisible = !this.isSearchBarVisible;
    if (!this.isSearchBarVisible) {
      this.searchTerm = '';
      this.resetData();
    }
  }
  toggleStatusBar() {
    this.isStatusBarVisible = !this.isStatusBarVisible;
  }
  clearModalStatus() {
    this.store.set({ modalStatus: false });
  }

  refreshPage(event) {
    if (this.segmentValue === '1') {
      this.resetEnqData();
    } else {
      this.resetBillData();
    }
    setTimeout(() => {
      event.target.complete();
    }, 800);
  }

  refresh(): void {
    window.location.reload();
  }

  ngOnInit() {
    this.enq.refreshList$.subscribe(() => {
      this.loadData();
    });

    this.route.params.subscribe(() => {
      try {
        const result = localStorage.getItem('store');
        if (result) {
          const storeData = JSON.parse(result);
          this.accType = storeData.acc_type;
          this.isAdmin = String(storeData.is_admin) === '1';
          this.enquiryConfig = storeData.enquiryConfig !== undefined ? Number(storeData.enquiryConfig) : 1;
          console.log('Account Type:', this.accType, 'isAdmin:', this.isAdmin, 'enquiryConfig:', this.enquiryConfig);
          this.statuses = this.buyerEnqStatuses;

          if (storeData.companyName.length > 1) {
            this.brandName = 'AzeApp';
          } else {
            this.brandName = storeData.companyName[0].companyName || 'AzeApp';
          }

          if (this.accType === 1) {
            this.statusBasedColorList['Pending For POD Approval'] = 'orange';
            this.statusBasedColorList['Dispatch Confirmation Pending'] =
              'orange';
            this.statuses = this.sellerEnqStatuses;
          } else if (this.accType === 2) {
            this.statusBasedColorList['Order Placed'] = 'red';
            this.statuses = this.sellerEnqStatuses;
          }
        } else {
          console.warn('No store data found in localStorage.');
        }
      } catch (error) {
        console.error('Error retrieving data:', error);
      }

      this.loadData();
    });

    this.searchSubject.pipe(debounceTime(500)).subscribe(() => {
      this.resetData();
    });
  }

  ngAfterViewInit(): void {
    this.setupIntersectionObserver();
  }

  private setupIntersectionObserver() {
    // Cleanup previous observer
    if (this.io) {
      this.io.disconnect();
      this.io = null;
    }
    
    // Only set up when anchor exists and has nativeElement
    if (!this.infiniteAnchor?.nativeElement) {
      console.warn('Infinite anchor not available yet');
      return;
    }

    this.io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !this.isLoading && this.hasMoreData) {
          this.onBottomReached();
        }
      },
      {
        root: null,
        rootMargin: '0px 0px 400px 0px',
        threshold: 0,
      }
    );

    this.io.observe(this.infiniteAnchor.nativeElement);
    console.log('IntersectionObserver set up successfully');
  }

  private onBottomReached(): void {
    if (this.isLoading || !this.isInfiniteScrollEnabled || !this.hasMoreData) return;
    if (this.segmentValue === '1') {
      this.loadEnquiries(true);
    } else {
      this.loadBills(true);
    }
  }

  loadData() {
    this.loadStatuses();
    this.resetData();
  }

  loadStatuses() {
    if (this.segmentValue === '1') {
      this.statuses =
        this.accType === 1 ? this.buyerEnqStatuses : this.sellerEnqStatuses;
    } else {
      this.statuses =
        this.accType === 1 ? this.buyerBillStatuses : this.sellerBillStatuses;
    }
  }

  loadEnquiries(isLoadMore: boolean = false) {
    // Show skeleton only for first page
    if (this.enqPage === 1 && !isLoadMore) this.enquiriesLoaded = false;
    this.isLoading = true;

    let params = new HttpParams().set('type', this.segmentValue);

    if (this.searchTerm && this.searchTerm.trim() !== '') {
      params = params.set('search', this.searchTerm);
    }

    if (this.selectedStatuses && this.selectedStatuses.length > 0) {
      const statusString = this.selectedStatuses.join(',');
      params = params.set('status', statusString);
    }

    params = params.set('page', this.enqPage.toString()).set('limit', this.limit.toString());

    this.enquirySubscription = this.http.get('retailers/indexEnquiries', { params }).subscribe({
      next: (res) => {
        this.enquiriesLoaded = true;

        if (res.code === 1) {
          const items = Array.isArray(res.data) ? res.data : [];
          this.enquiries = isLoadMore ? [...this.enquiries, ...items] : items;

          // pagination flags
          this.hasMoreData = items.length >= this.limit;
          this.isInfiniteScrollEnabled = this.hasMoreData;

          // increment page only if we actually got a full page
          if (this.hasMoreData) this.enqPage++;
        } else if (res.code === 2 && res.message === 'Invalid APIKEY') {
          this.signout();
        } else {
          this.hasMoreData = false;
          this.isInfiniteScrollEnabled = false;
        }
      },
      error: (err) => {
        this.enquiriesLoaded = true;
        this.hasMoreData = false; // prevent loops on error; you can adjust
        console.error('Error loading enquiries:', err);
        this.toastr.error('An error occurred. Please try again.', '', {
          timeOut: this.NotificationService.toastrTimeOut,
        });
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  onSearchInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.searchSubject.next(this.searchTerm);
  }

  resetData() {
    if (this.segmentValue === '1') {
      this.resetEnqData();
    } else {
      this.resetBillData();
    }
  }

  resetEnqData() {
    this.enquiries = [];
    this.enqPage = 1;
    this.hasMoreData = true;
    this.isInfiniteScrollEnabled = true;
    this.loadEnquiries(false);
  }

  resetBillData() {
    this.bills = [];
    this.billPage = 1;
    this.hasMoreData = true;
    this.isInfiniteScrollEnabled = true;
    this.loadBills(false);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    if (this.isInfiniteScrollEnabled && this.hasMoreData) {
      const container = this.listContainer.nativeElement;
      const containerBottom = container.getBoundingClientRect().bottom;
      const windowHeight = window.innerHeight;

      // Load more when user scrolls to within 100px of the bottom
      if (containerBottom - windowHeight < 100) {
        this.loadMoreData();
      }
    }
  }

  loadMoreData(event?: any): void {
    if (this.segmentValue === '1') {
      this.enqPage++;
      this.loadEnquiries(true);
    } else {
      this.billPage++;
      this.loadBills(true);
    }
  }

  loadBills(isLoadMore: boolean = false) {
    // Show skeleton only for first page
    if (this.billPage === 1 && !isLoadMore) this.enquiriesLoaded = false;
    this.isLoading = true;

    let params = new HttpParams().set('type', this.segmentValue);

    if (this.searchTerm && this.searchTerm.trim() !== '') {
      params = params.set('search', this.searchTerm);
    }

    if (this.selectedStatuses && this.selectedStatuses.length > 0) {
      const statusString = this.selectedStatuses.join(',');
      params = params.set('status', statusString);
    }

    params = params.set('page', this.billPage.toString()).set('limit', this.limit.toString());

    this.enquirySubscription = this.http.get('retailers/indexEnquiries', { params }).subscribe({
      next: (res) => {
        this.enquiriesLoaded = true;

        if (res.code === 1) {
          const items = Array.isArray(res.data) ? res.data : [];
          this.bills = isLoadMore ? [...this.bills, ...items] : items;

          // pagination flags
          this.hasMoreData = items.length >= this.limit;
          this.isInfiniteScrollEnabled = this.hasMoreData;

          if (this.hasMoreData) this.billPage++;
        } else if (res.code === 2 && res.message === 'Invalid APIKEY') {
          this.signout();
        } else {
          this.hasMoreData = false;
          this.isInfiniteScrollEnabled = false;
        }
      },
      error: (err) => {
        this.enquiriesLoaded = true;
        this.hasMoreData = false;
        console.error('Error loading bills:', err);
        this.toastr.error('An error occurred. Please try again.', '', {
          timeOut: this.NotificationService.toastrTimeOut,
        });
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  checkAppUpdate() {
    this.http.get('retailers/getVersion').subscribe((response) => {});
  }

  goTo(key: string, value: string) {
    if (key === 'new-enquiry') {
      const queryParams: any = {};
      if (value) {
        queryParams.enquiryType = value;
      }
      this.router.navigate(['/dashboard/new-enquiry'], { queryParams });
    } else if (key === 'simple-enquiry') {
      this.router.navigate(['/dashboard/simple-enquiry']);
    } else if (key === 'new-enquiry-bulk') {
      this.router.navigate(['/dashboard/new-enquiry-bulk']);
      this.isDropdownOpen = false;
    }
  }
  showBadges() {
    this.showStatusBar = true;
  }
  openEnqDetails(detail: any) {
    console.log('detail', detail);
    if (detail.enquiryNotesId) {
      this.router.navigate(['/dashboard/simple-enquiry-detail'], { queryParams: { note_id: detail.enquiryNotesId } });
    } else if (detail.enquiryId) {
      this.router.navigate(['/dashboard/enquiry-detail', detail.enquiryId]);
      this.enq.setEnqDetailData(detail);
    }
  }
  hideBadges() {
    this.showStatusBar = false;
  }
  confirmSignout() {
    this.isDropdownOpen = false;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out from the application.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, sign me out',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with sign out logic
        this.signout(); // Replace with your actual logout method
      }
    });
  }

  async signout() {
    this.http.get('retailers/logout').subscribe();
    //app.vvdconnect.in/
    http: setTimeout(() => {
      this.store.clearStore();
      this.user.reset();
      this.store.clearStore();
      this.router.navigate(['/login']);
    }, 300);
  }

  onSegmentChange(value: string) {
      this.segmentValue = value;
      this.selectedStatuses = [];
      this.loadStatuses();
      this.resetData();
      this.router.navigate(['/dashboard']);
  }

  getBackgroundColor(
    statusDescription: string,
    notificationCount: number
  ): string {
    if (statusDescription === 'Additional info required') {
      if (notificationCount > 0) {
        return 'red';
      } else {
        return 'orange';
      }
    } else {
      return this.statusBasedColorList[statusDescription] || 'orange';
    }
  }

  onStatusToggle(status: { id: number; name: string }) {
    const index = this.selectedStatuses.indexOf(status.id);

    if (index > -1) {
      this.selectedStatuses.splice(index, 1);
    } else {
      this.selectedStatuses.push(status.id);
    }

    this.resetData();
  }

  ngOnDestroy() {
    if (this.enquirySubscription) {
      this.enquirySubscription.unsubscribe();
    }
    if (this.io) {
      this.io.disconnect();
      this.io = null;
    }
    this.enquiries = [];
    this.bills = [];
    this.enqPage = 1;
    this.searchSubject.unsubscribe();
    console.log('destory work fine');
  }

  viewProfile() {
    this.isDropdownOpen = false;
    this.router.navigate(['/dashboard/profile']);
  }

  trackEnquiry(index: number, enq: any) {
    return enq.enquiryId;
  }

  trackBill(index: number, bill: any) {
    return bill.enquiryId;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  navigateToNewEnquiry() {
    this.router.navigate(['/dashboard/new-enquiry']);
  }

  handleCreateEnquiry() {
    this.router.navigate(['/dashboard/new-enquiry']);
  }
}
